<template>
  <div class="supplier-input">
    <div>
      <el-tag
        v-for="item of supplierList.slice(0, showCount)"
        :key="item.supplierNo"
        size="mini"
        type="info"
        style="margin-left: 6px;"
        :closable="true"
        @close="handleClose(item)"
      >
        {{ item.supplierName }}
      </el-tag>
      <span v-if="supplierList.length > showCount" class="over-label" @click="openDetails">{{ $t('common.soOn') }}{{ supplierList.length }}{{ $t('common.piece') }}</span>
    </div>
    <div>
      <i class="iconfont icon-gengduo" @click="showTable" />
    </div>
  </div>
</template>

<script>
import { supplierSearchDialog } from '../index'
import Dialog from '@utils/common/dialog'
import Table from '@utils/table'

const table = new Table('commonDialog')
  .sortable(false)
  .add('supplierNo')
  .add('supplierName')

const dialog = new Dialog('commonDialog')
  .title('checkSupplier')
  .dialog({ width: '50%' })
  .table(table)
  .isfooter(false)

export default {
  name: 'SupplierInput',
  components: {
    // DialogTable
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      showCount: 2,
      supplierList: []
    }
  },
  watch: {
    value(val) {
      if (val.length === 0 || !val) {
        this.supplierList = []
      }
    }
  },
  methods: {
    async showTable() {
      const res = await supplierSearchDialog.open()
      const selection = res.selection
      const value = [...this.supplierList]
      selection.forEach(item => {
        const existItem = value.find(x => x.supplierNo === item.supplierNo)
        if (!existItem) {
          value.push({ supplierName: item.supplierName, supplierNo: item.supplierNo })
        }
      })
      this.supplierList = value
      this.updateData()
    },
    updateData() {
      const supplierNos = []
      for (let i = 0; i < this.supplierList.length; i++) {
        supplierNos.push(this.supplierList[i].supplierNo)
      }
      this.$emit('input', supplierNos)
    },
    handleClose(item) {
      for (let i = 0; i < this.supplierList.length; i++) {
        if (this.supplierList[i].supplierNo === item.supplierNo) {
          this.supplierList.splice(i, 1)
          break
        }
      }
      this.updateData()
    },
    // 查看隐藏的选项
    async openDetails() {
      const api = async() => {
        return Promise.resolve({
          records: this.supplierList,
          total: this.supplierList.length
        })
      }
      await dialog.open({ attrs: { api }})
    }
  }
}
</script>

<style lang="scss" scoped>
  .supplier-input {
    height: 32px;
    width: 100%;
    border: 1px solid #DCDFE6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px 0 0;
    box-sizing: border-box;
    &:hover {
      border-color: #C0C4CC;
    }
    .icon-gengduo {
      cursor: pointer;
      &:hover {
        background: #F2F6FF;
      }
    }
    .over-label {
      cursor: pointer;
      height: 17px;
      font-family: PingFangHK-Regular,serif;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      margin-left: 6px;
    }
  }
</style>
